import { Dokument } from './dokument';
import { BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseContainerService } from 'yt-ng-framework';
import { DokumentStavka } from './dokument-stavka_old';
import { FormGroup, Validators } from '@angular/forms';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-dokument-update',
  templateUrl: './dokument-update.component.html'
})
export class DokumentUpdateComponent extends BaseUpdateComponent<Dokument> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService

  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    //this.detailFgName="Stavke";

    super.ngOnInit();

    //this.dokumentForm=this.genFgFromModel(new Dokument(), new DokumentStavka());
    //this.GetFormGroupFromModel();
    //this.disabledControls();
    //this.addValidatorToFc('PodVrstaDokumentaID', Validators.required, 'reqyured', 'DOKUMENT.PODVRSTADOKUMENTA.VALIDATION.REQUIRED');
    //this.addValidatorToFc('BrojDokumenta', Validators.required, 'required', 'DOKUMENT.BROJDOKUMENTA.REQUIRED');
    this.addValidatorToFc('Datum', Validators.required, 'required', 'DOKUMENT.DATUM.VALIDATION.REQUIRED');
    // this.addValidatorToFc('Komitent', Validators.required);
    //this.addValidatorToFc('Stavke.Roba', Validators.required);
    // this.addValidatorToFc('Stavke.Magacin', Validators.required);
    // this.addValidatorToFc('Stavke.Kolicina', Validators.required);
    // this.addValidatorToFc('Stavke.DobavljacCena', Validators.required);
    // this.addValidatorToFc('Stavke.UlazniRabatProcenat', Validators.required);
    // this.addValidatorToFc('Stavke.ProdajnaCena', Validators.required);
    // this.addValidatorToFc('Stavke.RabatProc', Validators.required);

    
  }

  editMode:boolean=false;
  AddDocument() { }
  //Print(ID1) { }
  item:any;
  PrintKnj(item1){}
  SaveMaster(qq){}
}
